import { render, staticRenderFns } from "./honorCenter.vue?vue&type=template&id=470e63f7&scoped=true"
import script from "./honorCenter.vue?vue&type=script&lang=js"
export * from "./honorCenter.vue?vue&type=script&lang=js"
import style0 from "./honorCenter.vue?vue&type=style&index=0&id=470e63f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e63f7",
  null
  
)

export default component.exports